"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface AppPageLayoutV2Props {
  children: React.ReactNode;
  outerPadding?: "default" | "none";
  contentPadding?: "default" | "none";
  withFrame?: boolean;
  className?: never;
  frameClassName?: string;
  contentClassName?: string;
}

/**
 * Layout base unificado para páginas v2.
 *
 * - Centraliza la configuración del spectrum band (el gradiente bajo el navbar).
 * - Permite usar o no frame interno según la página.
 */
export function AppPageLayoutV2({
  children,
  outerPadding = "default",
  contentPadding = "default",
  withFrame = true,
  className,
  frameClassName,
  contentClassName
}: AppPageLayoutV2Props) {
  React.useEffect(() => {
    const appMainScroll = document.getElementById("app-main-scroll");
    if (!appMainScroll) return;

    appMainScroll.style.setProperty("--site-spectrum-duration", "2000ms");
    appMainScroll.style.setProperty(
      "--site-spectrum-easing",
      "cubic-bezier(0.16, 1, 0.3, 1)"
    );
    appMainScroll.style.setProperty("--site-spectrum-iterations", "1");
    appMainScroll.style.setProperty("--site-spectrum-fill", "forwards");
    appMainScroll.style.setProperty("--site-spectrum-start-x", "0%");
    appMainScroll.style.setProperty("--site-spectrum-end-x", "72%");

    return () => {
      appMainScroll.style.removeProperty("--site-spectrum-duration");
      appMainScroll.style.removeProperty("--site-spectrum-easing");
      appMainScroll.style.removeProperty("--site-spectrum-iterations");
      appMainScroll.style.removeProperty("--site-spectrum-fill");
      appMainScroll.style.removeProperty("--site-spectrum-start-x");
      appMainScroll.style.removeProperty("--site-spectrum-end-x");
    };
  }, []);

  const outer = cn(
    outerPadding === "default" ? "p-3 md:p-6" : "p-0",
    className
  );

  if (!withFrame) {
    return <div className={outer}>{children}</div>;
  }

  return (
    <div className={outer}>
      <div
        className={cn(
          "min-h-screen rounded-xl bg-slate-50/40 dark:bg-zinc-950/40",
          frameClassName
        )}
      >
        <div
          className={cn(
            contentPadding === "none" ? "p-0" : "p-6",
            contentClassName
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
